import { DesktopContainer, MobileContainer } from 'core/Theming/Device';
import { useMemo } from 'react';
import { Toast } from './Toast';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  duration?: number;
  severity: 'error' | 'warning' | 'success' | 'info';
  position?: {
    mobile: {
      vertical: 'top' | 'bottom';
      horizontal: 'left' | 'center' | 'right';
    };
    desktop: {
      vertical: 'top' | 'bottom';
      horizontal: 'left' | 'center' | 'right';
    };
  };
}

export default function PrimaryToast({
  isOpen,
  onClose,
  message,
  duration,
  severity,
  position = {
    mobile: { vertical: 'bottom', horizontal: 'center' },
    desktop: { vertical: 'top', horizontal: 'center' },
  },
}: Props) {
  const displayDuration = useMemo<number | undefined>(() => {
    if (severity == 'error') {
      if (duration) return duration;
    } else return 5000;
  }, [severity, duration]);
  return (
    <>
      <DesktopContainer>
        <Toast
          message={message}
          isOpen={isOpen}
          onClose={onClose}
          severity={severity}
          duration={displayDuration}
          position={position.desktop}
        />
      </DesktopContainer>
      <MobileContainer>
        <Toast
          message={message}
          isOpen={isOpen}
          onClose={onClose}
          severity={severity}
          duration={displayDuration}
          position={position.mobile}
        />
      </MobileContainer>
    </>
  );
}
